import SpecialistSessionReviewAPI from "api/SpecialistSessionReviewAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistSessionReviews( params: SpecialistSessionReviewGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistSessionReviewAPI.getAll,
      params: [ params ],
      debounce: true,
      clear_data_on_update: true
   })
}